module.exports={
	"Form": "MixSpecificationEditManifest",
	"Scope": "MixSpecification-Edit",
	"Descriptors":
	{
		"MixSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixSpecification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixSpecification-Edit-Identity",
				"Group": "MixSpecification-Edit-Identity"
			}
		},
		"MixSpecificationDetails.Code":
		{
			"Name": "Code",
			"Hash": "MixSpecification-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixSpecification-Edit-Identity",
				"Group": "MixSpecification-Edit-Identity"
			}
		},
		"MixSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixSpecification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.MaterialType":
		{
			"Name": "Material Type",
			"Hash": "MixSpecification-Edit-MaterialType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "MixSpecification-Edit-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "MixSpecification-Edit-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ApprovalDate":
		{
			"Name": "Approval Date",
			"Hash": "MixSpecification-Edit-ApprovalDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.ApprovingIDUser":
		{
			"Name": "Approving IDUser",
			"Hash": "MixSpecification-Edit-ApprovingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "MixSpecification-Edit-Details",
				"Group": "MixSpecification-Edit-Details"
			}
		},
		"MixSpecificationDetails.IDMixSpecification":
		{
			"Name": "IDMix Specification",
			"Hash": "MixSpecification-Edit-IDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.GUIDMixSpecification":
		{
			"Name": "GUIDMix Specification",
			"Hash": "MixSpecification-Edit-GUIDMixSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixSpecification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixSpecification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixSpecification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		},
		"MixSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixSpecification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixSpecification-Edit-DataAudit",
				"Group": "MixSpecification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixSpecification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixSpecification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixSpecification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixSpecification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixSpecification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixSpecification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
